import type { QuizSetDetailsRes } from '@/api/gen/_model/quizSetDetailsRes';
import { useCTAHandlers } from '../hooks/useCTAHandlers';
import { type CTAScenario } from '../hooks/useCTAScenario';
import { MobileGuestCTAButtons } from './MobileGuestCTAButtons';
import { MobileOwnerCTAButtons } from './MobileOwnerCTAButtons';
import { MobileOwnerLockedCTAButtons } from './MobileOwnerLockedCTAButtons';
import { MobileViewerCTAButtons } from './MobileViewerCTAButtons';
import { MobileViewerLockedCTAButtons } from './MobileViewerLockedCTAButtons';
export interface MobileCTAButtonGroupProps {
  scenario: CTAScenario;
  quizId: string;
  quizData: QuizSetDetailsRes;
}
export const MobileCTAButtonGroup = ({
  scenario,
  quizId,
  quizData
}: MobileCTAButtonGroupProps) => {
  const {
    handleEnter,
    handleShare,
    handleDuplicate,
    handleEdit,
    handleGoToLms,
    handleDuplicateLocked,
    handleUpgradePlan,
    handleMoveToFolder
  } = useCTAHandlers({
    quizId,
    quizData,
    scenario
  });
  switch (scenario) {
    case 'guest':
      return <MobileGuestCTAButtons onCopy={handleDuplicate} onEnter={handleEnter} />;
    case 'owner':
      return <MobileOwnerCTAButtons onEnter={handleEnter} onShare={handleShare} onDuplicate={handleDuplicate} onEdit={handleEdit} onMoveToFolder={handleMoveToFolder} />;
    case 'viewer':
      return <MobileViewerCTAButtons onDuplicate={handleDuplicate} onEnter={handleEnter} />;
    case 'owner-locked':
      return <MobileOwnerLockedCTAButtons onDuplicateLocked={handleDuplicateLocked} onUpgradePlan={handleUpgradePlan} onGoToLms={handleGoToLms} onEdit={handleEdit} onMoveToFolder={handleMoveToFolder} />;
    case 'viewer-locked':
      return <MobileViewerLockedCTAButtons onCopy={handleDuplicate} />;
    default:
      {
        const _exhaustiveCheck: never = scenario;
        return null;
      }
  }
};